import * as React from "react";
const TypeCell = ({ type, inputTypes = void 0 }) => {
  const typeName = inputTypes && (inputTypes == null ? void 0 : inputTypes.types[type]);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, typeName || type);
};
export default TypeCell;
